/**
 * Mirrors backend/src/utils/branchScope.ts's GLOBAL_BRANCH_SCOPE_ROLES —
 * Super Admin (system-wide override), Lead Manager (dedicated central
 * lead-distribution operator) and Admission Officer (central admissions)
 * see every branch's data. This is a UX
 * convenience for labeling/gating cosmetic UI (page titles, the header
 * branch switcher) — the backend is the actual source of truth for data
 * scoping, this constant just keeps the two frontend call sites from
 * silently drifting out of sync with each other.
 */
export const GLOBAL_BRANCH_SCOPE_ROLES = ['Super Admin', 'Lead Manager', 'Admission Officer'];
